import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="centerPage">
      <div className="card pageNarrow wFull">
        <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: "-0.015em", marginBottom: 6 }}>Not found</div>
        <div className="muted" style={{ marginBottom: 12 }}>
          The page you requested doesn’t exist.
        </div>
        <Link to="/" className="btn btnPrimary">
          Go home
        </Link>
      </div>
    </div>
  );
}

